import React, { useEffect, useRef, useState } from "react";

import building from "../../../../../../assets/images/svg/110-hotel-1.svg";
import { FormActivity } from "./forms/formActivity";
import * as R from "ramda";

export const Activity = ({ activities, isLoading, userId, relocationDeclaration }) => {

	// activities = R.sortBy(R.prop("position"), activities) || [];

	const [editMode, setEditMode] = useState(false);

	return (
		<section className="card mb-sm mt-nsm rounded-top-0 bg-common pb-4">
			<div className="card-header pb-0 bg-none">
				<div className="grid grid-md-2 align-items-center bg-white px-3 py-1 rounded">
					<h2 className="h6 text-uppercase text-default font-weight-bolder my-auto">
						{/* <div className="btn btn-square btn-secondary p-2 mr-2 fs-3 font-weight-bold rounded-sm">2</div> */}
						<span className="">En activite(e)</span>
					</h2>
					<div className="grid grid-2 ml-auto align-items-center">
						<button
							type="button"
							className="btn btn-icon p-1 align-middle o-80 o-100--hover mx-auto"
							onClick={() => {
								setEditMode(true);
							}}>
							<i className="eva eva-edit-2-outline align-middle fs-lead"></i>
						</button>
						<div className="custom-control custom-switch mx-auto">
							<input type="checkbox" className="custom-control-input" id="activitySwitchCheckDefault" required="required" defaultChecked={relocationDeclaration?.onBoardingStep > 3} />
							<label className="custom-control-label" htmlFor="activitySwitchCheckDefault">
								Valider
							</label>
						</div>
					</div>
				</div>
				{/* <hr className="mb-0" /> */}
			</div>
			{!editMode ? (
				<div className="card-body gy-2">
					{!R.isNil(activities) && activities.length > 0 ? (
						activities.map((activity) => {
							return (
								<div className="grid grid-sm-2 grid-lg-3 grid-xl-5" key={"activite_" + activity.id}>
									<div className="block flex-row align-items-center">
										<img className="img-fluid mr-3 h-4" src={building} alt="building" />
										<p className="h6 text-uppercase font-weight-bold my-auto">{activity.payload.companyName}</p>
									</div>
									<div className="flex-row align-items-start">
										<i className="eva lh-copy eva-home-outline mr-2 o-50"></i>
										<p className="h5 lh-copy my-auto">
											{activity.payload.companyAddressStreet1}{" "}
											{!R.isNil(activity.payload.companyAddressStreet2) && activity.payload.companyAddressStreet2 !== "" ? (
												<React.Fragment>
													<br />
													{activity.payload.companyAddressStreet2}
												</React.Fragment>
											) : (
												""
											)}
											<br />
											{activity.payload.companyAddressPostalCode} {activity.payload.companyAddressLocality}, {activity.payload.companyAddressCountry}
										</p>
									</div>
									<div className="block flex-column align-items-start">
										<p className="h5 text-uppercase font-weight-bold my-auto o-70">Intitulé du poste</p>
										<p className="h6 text-uppercase font-weight-bold my-auto">
											{activity.payload.function}
											<br />
											{activity.payload.contractType === "Trial" ? "Autre" : activity.payload.contractType}
										</p>
									</div>
									<div className="block flex-column align-items-start">
										<p className="h6 text-uppercase font-weight-bold my-auto o-40">Plan d'épargne entreprise</p>
										<p className="h6 text-uppercase font-weight-bold my-auto">{activity.payload.companySavingsPlanReference !== "" ? "Oui" : "Non"}</p>
									</div>
									{/* <div className="block flex-column align-items-start">
                                <p className="h6 text-uppercase font-weight-bold my-auto o-40">DÉCÈS SUITE À UN ACCIDENT DE TRAVAIL OU MALADIE PROFESSIONNELLE</p>
                                <p className="h6 text-uppercase font-weight-bold my-auto">{activity.id === relocationDeclaration?.diedInActivityId ? 'Oui' : 'Non'}</p>
                            </div> */}
								</div>
							);
						})
					) : (
						<div className="card-body flex-row">
							<i className="eva fs-5 text-primary eva-slash-outline mr-2 mt-border"></i>
							<div className="block">
								<h1 className="h1 mb-0">C'est vide...</h1>
								<p className="mt-0 o-80">Compléter votre situation professionnelle</p>
								<button
									type="button"
									onClick={() => {
										setEditMode(true);
									}}
									className="btn btn-white-primary text-primary">
									Ajouter
								</button>
							</div>
						</div>
					)}
				</div>
			) : (
				<FormActivity activities={activities} isLoading={isLoading} userId={userId} relocationDeclaration={relocationDeclaration} setEditMode={setEditMode} />
			)}
		</section>
	);
};
